const RefundGooglePurchase = {
  path: '/refund/google',
  name: 'refundGooglePurchase',
  component: () => import('../views/refund/google.vue'),
}

module.exports = {
  RefundGooglePurchase,
}